(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var ajaxLoading = false;

    
    //auto complete
    $.widget("custom.catcomplete", $.ui.autocomplete, {
        _create: function () {
            this._super();
            this.widget().menu(
                "option",
                "items",
                "> :not(.ui-autocomplete-category)"
            );
        },
        _renderMenu: function (ul, items) {
            var that = this,
                currentCategory = "";
            $.each(items, function (index, item) {
                var li;
                if (item.themes != currentCategory) {
                    ul.append(
                        "<li class='ui-autocomplete-category'>" +
                            item.themes +
                            "</li>"
                    );
                    currentCategory = item.themes;
                }
                li = that._renderItemData(ul, item);
                if (item.themes) {
                    li.attr("aria-label", item.themes + " : " + item.label);
                    li.attr("data-permalink", item.permalink);
                }
            });
        },
    });

    var jsonData = (function () {
        var json = null;
        $.ajax({
            async: false,
            global: false,
            url: "/wp-content/themes/melbourne-queer-film-festival/assets/dist/files/shows_autocomplete.json",
            dataType: "json",
            success: function (data) {
                json = data;
            },
        });
        return json;
    })();

    $(".search__field").catcomplete({
        delay: 0,
        minLength: 2,
        source: jsonData,
        autoFocus: true,
        focus: function (event, ui) {
            event.preventDefault();
        },
        select: function (index, li) {
            if (li.item.permalink) {
                window.location.href = li.item.permalink;
            }
        },
    });

    //date picker
    function initFlatpickr() {
        $(".flatpickr").each(function () {
            var $this = $(this);

            var i = flatpickr(".flatpickr", {
                disableMobile: true,
                clickOpens: "false",
                altInput: true,
                dateFormat: "d-m-Y",
                maxDate: "23-3-2020",
                minDate: "12-3-2020",
                onChange: function (selectedDates, dateStr) {
                    var str = selectedDates
                        .toString()
                        .replace("00:00:00 GMT+1100 (AEDT)", "");
                    str = str.replace("00:00:00 GMT+1000 (AEST)", "");
                    $this
                        .next()
                        .find("span")
                        .text("(" + str + ")");

                    document.location.href =
                        crb_options.movies_page_url + "?date=" + dateStr;
                },
                onReady: function (instance) {
                    $(".bar__btn--date-picker").on(
                        "click touchstart",
                        function (e) {
                            e.preventDefault();
                            $(this).toggleClass("open");

                            if ($(this).hasClass("open")) {
                                i.open();
                            } else {
                                i.close();
                            }

                            return false;
                        }
                    );
                },
            });
        });
    }

    $(".bar__btn--date-picker").on("click", function () {
        $(".flatpickr").toggleClass("active");
    });

    if ($("body").hasClass("page-id-27")) {
        $(function () {
            $(".article__content").matchHeight();
        });
    }

    $(".js-filters-toggle").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);
        var $bar = $this.closest(".bar__entry");

        var activeClass = "filters-visible";
        var $col = $this.closest(".col");

        $("." + activeClass)
            .not($bar)
            .not($col)
            .removeClass(activeClass);

        $bar.toggleClass(activeClass);

        if ($col.hasClass("col--pick-film")) {
            $col.toggleClass(activeClass);
        } else {
            $col.removeClass(activeClass);
        }
    });

    $(".movie-filter-list").on("change", function () {
        var value = $(this).val();
        if (value !== "") {
            document.location.href = value;
        }
    });

    $(".btn--tickets").on("click", function () {
        var $scrolTo = "";

        if ($win.width() > 767) {
            //desktop
            $scrolTo = $(".section-split");
        } else {
            //mobile
            $scrolTo = $(".verve-details");
        }

        $("html, body").animate(
            {
                scrollTop: $scrolTo.offset().top,
            },
            1000
        );

        return false;
    });

    $(".form__bar--btn > a").on("click", function (e) {
        e.preventDefault();

        $(this).siblings(".extra__content").slideToggle(300);
    });

    //Equal Height Function
    $.fn.equalizeHeight = function () {
        var hght = 0;
        var $this = this;

        $this.outerHeight("auto");

        $this.each(function () {
            var itemHght = $(this).outerHeight();

            if (itemHght > hght) {
                hght = itemHght;
            }
        });

        $this.outerHeight(hght);
    };

    // Signup Close
    $(".signup__btn").on("click", function (e) {
        e.preventDefault();

        $(".signup").removeClass("signup--visible");
    });

    $(".signup").on("click", function (e) {
        if (e.target !== this) return;

        $(".signup").removeClass("signup--visible");
    });

    //open video and play
    $(".video__btn").on("click", function (e) {
        e.preventDefault();

        $(".signup").addClass("signup--visible");

        $(".signup iframe")[0].src += "?autoplay=1";
    });

    function initVenueMaps() {
        $(".signup__map").each(function () {
            var $this = $(this);
            var lat = $this.data("lat");
            var lng = $this.data("lng");
            var zoom = 17;
            var image = crb_options.theme_url + "/assets/dist/images/map-pin.png";
            var signupContainer = $(this).parents(".signup");

            if ($win.width() <= 767) {
                zoom = 16;
            }

            var coords = new google.maps.LatLng(lat, lng);
            var map = new google.maps.Map(
                document.getElementById($this.attr("id")),
                {
                    zoom: zoom,
                    center: coords,
                    icon: image,
                    gestureHandling: "greedy",
                }
            );

            var marker = new google.maps.Marker({
                position: coords,
                map: map,
                icon: image,
            });

            var showMapBtn = $this
                .parents(".article__content")
                .find(".js-map-toggle");

            showMapBtn.on("click", function () {
                $(".signup").removeClass("signup--visible");
                signupContainer.toggleClass("signup--visible");
            });
        });
    }

    // Scroll Animations
    $(".fade").each(function (i) {
        var $this = $(this);

        if ($("body.page-template-movies").length) {
            if (i < 6) {
                $(this).addClass("fade-in");
            }
        }

        $win.on("scroll", function () {
            if (
                $win.scrollTop() + $win.outerHeight() >=
                $this.offset().top + $this.outerHeight() - 400
            ) {
                $this.addClass("fade-in");
            }
        });
    });

    //create slider for mive pages

    if (
        $("body").hasClass("crb_movie-template-default") ||
        $("body").hasClass("page-template-homepage")
    ) {
        $(".slider").on(
            "init",
            function (event, slick, currentSlide, nextSlide) {
                $(".bar").css("opacity", "1");
                $(".slide").css("opacity", "1");
            }
        );

        var autoPlay = true;

        $(".slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: autoPlay,
            arrows: false,
            dots: false,
            speed: 900,
            autoplaySpeed: 4000,
            fade: true,
            pauseOnHover: false,
        });
    }

    function initHeaderNavPos() {
        let observer;
        let header = document.querySelector(".header");

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(header);
    }

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.remove("is-passed");
            } else {
                entry.target.classList.add("is-passed");
            }
        });
    }

    $win.on("load", function () {
        if ($("body.page-template-movies").length == 1) {
            initFlatpickr();
        }

        initVenueMaps();

        $(".fade-in-anim").each(function () {
            $(this).addClass("faded-in");
        });

        //add javascript link to login menu item
        $(".verve--login-link").on("click", function (e) {
            e.preventDefault();
            // olark code here
            ferve.utility.openLink("account", 0);
        });

        //swap film page you may like wishlist imgs
        $(".section--related article .favourite-btn").each(function (i) {
            var $this = $(this);

            var $image = $this.find(" img");
            var src = $image.attr("src");

            if (src.indexOf("wishlist_on_blue") >= 0) {
                $this.addClass("on");
            }

            $this.on("click", function () {
                $this.toggleClass("on");
            });
        });

        initHeaderNavPos();
    });

    $("#js-menu").on("click", function (e) {
        e.preventDefault();
        $(".header__body").slideToggle("slow");
        $(this).text($(this).text() == "Close" ? "Menu" : "Close");
    });

    $(".js-footer-accordion").on("click", function (e) {
        e.preventDefault();

        let $this = $(this);
        let $accordion = $this.parent(".footer__links");

        if ($accordion.hasClass("is-open")) {
            $accordion
                .removeClass("is-open")
                .children(".links__content")
                .slideUp();
        } else {
            $accordion.addClass("is-open");
            $accordion.children(".links__content").slideDown();
            $accordion
                .siblings()
                .removeClass("is-open")
                .children(".links__content")
                .slideUp();
        }
    });

    function headerHeight() {
        let $container = $(".header__container");
        let container_pt = parseInt($container.css("padding-top"));
        let container_pb = parseInt($container.css("padding-bottom"));
        let head_h = $(".header__head").outerHeight();

        let header_height = container_pt + head_h + container_pb;
        let container_height = $(".header__container").outerHeight();

        $(".wrapper").css({
            "--header-height": header_height.toString() + "px",
            "--header-height-expanded": container_height.toString() + "px",
        });
    }

    $win.on("resize", headerHeight);

    $(document).ready(headerHeight);

    $(document).ready(function () {
        $(".popup-youtube").magnificPopup({
            disableOn: 700,
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
        });
    });

    const userAgent = window.navigator.userAgent;

    function isIe() {
        return userAgent.indexOf("Trident/") > 0;
    }

    if (isIe()) {
        $(".js-image-fit").each(function (i, container) {
            const $container = $(container);
            const $image = $container.find("img");
            const imageSource = $image.attr("src") || $image.data("src");
            $container.css("background-image", "url(" + imageSource + ")");
            $image.addClass("sr-only");
        });
    }

    $(".menu-item-has-children").on("click", function (e) {
        if ($(window).width() >= 768) {
            return;
        }

        if ($(e.target).is("a")) {
            return;
        }

        e.preventDefault();
        let $this = $(this);

        if ($this.hasClass("is-open")) {
            $this.removeClass("is-open").children("ul").slideUp();
        } else {
            $this.addClass("is-open");
            $this.children("ul").slideDown();
            $this.siblings().removeClass("is-open").children("ul").slideUp();
        }
    });

    // Movie Filter Options
    $(".js-filter-form").on("submit", function (e) {
        e.preventDefault();

        if (ajaxLoading) {
            return;
        }

        $form = $(this);

        var data = $form.serializeArray();

        $.ajax({
            method: "GET",
            url: window.location.href,
            data: data,
            beforeSend: function () {
                ajaxLoading = true;
                $form.find(".gform_ajax_spinner").removeClass("hidden");
            },
            success: function (response) {
                var newMovies = $(response).find(".js-movies").html();
                $(".js-movies").html(newMovies);
            },
            error: function (response) {
                console.error(response);
            },
            complete: function () {
                ajaxLoading = false;
                $form.find(".gform_ajax_spinner").addClass("hidden");
                $("html, body").animate(
                    {
                        scrollTop: $form.offset().top,
                    },
                    500
                );
            },
        });
    });

    $(".js-reset").on("click", function (event) {
        event.preventDefault();

        $(".js-filter-form").trigger("reset");

        $.ajax({
            method: "GET",
            url: window.location.href,
            data: {},
            success: function (response) {
                var newMovies = $(response).find(".js-movies").html();
                $(".js-movies").html(newMovies);
                $("html, body").animate(
                    {
                        scrollTop: $(".js-filter-form").offset().top,
                    },
                    500
                );
            },
            error: function (response) {
                console.error(response);
            },
        });
    });

    $(".plyr").each(function () {
        try {
            let $this = $(this);

            let videoId = $this.attr("id");
            let autoplay = $this.attr("data-autoplay") === "true";
            let videoType = $this.data("video-type");
            let poster = $this.attr("data-poster");
            let allowFullscreen =
                $this.attr("data-allow-fullscreen") === "true";

            let controls =
                $this.attr("data-controls") === "true"
                    ? [
                          "play-large",
                          "play",
                          "progress",
                          "current-time",
                          "mute",
                          "volume",
                          "captions",
                          "settings",
                          "pip",
                          "airplay",
                          "fullscreen",
                      ]
                    : [];
            if ($this.attr("data-mute-button") === "true") {
                controls = ["mute"];
            }

            const videoSettings = {
                clickToPlay: $this.attr("data-click-to-play") === "true",
                controls: controls,
                loop: { active: $this.attr("data-loop") === "true" },
                autoplay: autoplay && videoType === "embed",
                fullscreen: { enabled: allowFullscreen },
                storage: { enabled: false },
            };

            const player = new Plyr("#" + videoId, videoSettings);

            // Get the classes from the initial Plyr element
            let classes = $this.attr("class");

            // Add the classes to the new Plyr element
            $(player.elements.container).addClass(classes);

            if (poster) {
                player.poster = $this.attr("data-poster");
            }

            if (autoplay && videoType === "file") {
                player.volume = 0;
                player.muted = true;
            }

            const config = {
                rootMargin: "-15% 0%",
                threshold: 0,
            };

            const callback = (entries) => {
                entries.map((entry) => {
                    entry.isIntersecting && autoplay && player
                        ? player.play()
                        : player.pause();
                });
            };

            let observer = new IntersectionObserver(callback, config);

            player.on("ready", () => {
                player.pause();
                player.muted = true;
                player.volume = 0;
                observer.observe($this[0]);
            });
        } catch (error) {
            if (error.message !== "Plyr is not defined") {
                console.error("Error initializing Plyr:", error);
            } else {
                console.error("Plyr is not defined.");
            }
        }
    });

    $(".js-read-more").each(function () {
        let $readMore = $(this);

        $readMore.on("click", function (e) {
            e.preventDefault();

            let $this = $(this);
            let $card = $this.closest(".card");
            let $siblingCards = $card.siblings(".card");

            // Remove 'is-active' class from all sibling cards
            $siblingCards.removeClass("is-active");

            // Toggle 'is-active' class on the clicked card
            $card.toggleClass("is-active");
        });
    });
})(jQuery, window, document);
